import React, { useState } from 'react';
import { BsX } from 'react-icons/bs';
import MultiScanForm from '../../../../components/MultiScanForm/MultiScanForm';
import { useTranslation } from 'react-i18next';

interface ScannerProps {
	isActive: boolean;
	scanType: 'order' | 'item';
	onScan: (barcode: string) => void;
	onClose: () => void;
}

export const Scanner: React.FC<ScannerProps> = ({ isActive, scanType, onScan, onClose }) => {
	const [scanInput, setScanInput] = useState('');

	const { t } = useTranslation();

	if (!isActive) return null;

	const checkScan = async (scanned:string) => { 
		return scanned;
	};

	const runSearch = async (scanned:string) => {
		await onScan(scanned);
		return true;
	};

	

	return (
		<div 
			// className="bg-white rounded-lg shadow-md p-4 mt-2"
		>
			{/* <div className="flex items-center justify-between mb-3">
				<h3 className="font-semibold text-base">
					{scanType === 'order' ? 'Auftrag' : 'Artikel'} scannen
				</h3>
				<button onClick={onClose} className="text-gray-500 hover:text-gray-700">
					<BsX size={20} />
				</button>
			</div> */}

			<MultiScanForm 
				checkScan={checkScan}
				runSearch={runSearch}

				inputLabel={t("common:scanPlaceholder." + (scanType === 'order' ? 'salesOrder' : 'salesArticle')) ?? ""}

				defaultActive={false}
			/>

			{/* <input
				type="text"
				value={scanInput}
				onChange={(e) => setScanInput(e.target.value)}
				onKeyDown={(e) => {
					if (e.key === 'Enter' && scanInput) {
						onScan(scanInput);
						setScanInput('');
					}
				}}
				placeholder={`${scanType === 'order' ? 'Auftrags' : 'Artikel'}-Barcode eingeben...`}
				className={`w-full p-3 border-2 ${scanType === 'order' ? 'border-blue-500' : 'border-green-500'} rounded-lg text-lg`}
				autoFocus
			/> */}
			{/* <p className="text-sm text-gray-600 mt-2">Drücken Sie Enter nach dem Scannen</p> */}
		</div>
	);
};